import './App.scss';
import { Route, Routes } from 'react-router-dom';
import { MainPage } from './pages/MainPage/MainPage';
import RegistrationPage from './pages/RegistrationPage/RegistrationPage';
import AuthorizationPage from './pages/AutorizationPage/AuthorizationPage';
import Layout from './components/Layout/Layout';
import { StatisticsPage } from './pages/StatisticsPage/StatisticsPage';
import { RequireAuth } from './hoc/RequireAuth';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* <Route path="/" element={<Layout />}> */}
        <Route path="/portal_app" element={<Layout />}>
          <Route index element={<AuthorizationPage />} />
          <Route
            path="registration"
            element={
              <RequireAuth>
                <RegistrationPage />
              </RequireAuth>
            }
          />
          <Route
            path="main"
            element={
              <RequireAuth>
                <MainPage />
              </RequireAuth>
            }
          />
          <Route
            path="statistics"
            element={
              <RequireAuth>
                <StatisticsPage />
              </RequireAuth>
            }
          />
          <Route path="authorization" element={<AuthorizationPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
